module.exports = __webpack_public_path__ + "static/media/nestingdesign-IG-3.32c9aa0d.PNG";